import { Component } from "react";
import { Switch, Route, Redirect } from 'react-router-dom';

import RunAssessmentClientView from "../component/features/run-assessments/RunAssessmentClientView";

export class ReportRouter extends Component {
    
    render() {
        return (
            <Switch>
                <Route exact path={"/reports/assessments/:reportValue"} component={RunAssessmentClientView} />
                <Redirect to="/not-found" />
            </Switch>
        )
    }
};